const VALUES = {
  gridLinesColor: '#96C5FA',
  gridLinesOpacity: 0.75,
  lightColor: '#FFFDED',
  lightIntensity: 1,
  backgroundColor: '#1c2b5a',
  backgroundIntensity: 0.3,
};

export const defaultValues = {
  background: {
    color: VALUES.backgroundColor,
    intensity: VALUES.backgroundIntensity,
  },
  grid: {
    color: VALUES.gridLinesColor,
    intensity: VALUES.gridLinesOpacity,
  },
  ambience: {
    color: VALUES.lightColor,
    intensity: VALUES.lightIntensity,
  },
};
